// import React, { useEffect } from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { useAuthStore } from './store/auth.store';
// import { registerSyncListeners } from './lib/offline/sync';
// import LoginPage       from './features/auth/pages/LoginPage';
// import MfaSetupPage   from './features/auth/pages/MfaSetupPage';
// import SessionsPage   from './features/sessions/pages/SessionsPage';
// import DashboardLayout from './components/layout/DashboardLayout';
// import OpdQueuePage    from './features/opd/pages/OpdQueuePage';
// import UsersPage       from './features/users/pages/UsersPage';
// import OnboardingPage  from './features/onboarding/pages/OnboardingPage';
// import AdminLayout     from './features/admin/pages/AdminLayout';
// import AdminDashboard  from './features/admin/pages/AdminDashboard';
// import HospitalsList   from './features/admin/pages/HospitalsList';
// import HospitalDetail  from './features/admin/pages/HospitalDetail';
// import RbacMatrix           from './features/admin/pages/RbacMatrix';
// import AuthDebugPage        from './features/admin/pages/AuthDebugPage';
// import SystemLogsPage      from './features/admin/pages/SystemLogsPage';
// import PlansPage            from './features/admin/pages/PlansPage';
// import UpgradeRequestsPage  from './features/admin/pages/UpgradeRequestsPage';
// import AdminSupportPage     from './features/admin/pages/AdminSupportPage';
// import SubscriptionPage     from './features/hospital/pages/SubscriptionPage';
// import IpdBedBoardPage     from './features/ipd/pages/IpdBedBoardPage';
// import LabPage             from './features/lab/pages/LabPage';
// import RadiologyPage       from './features/radiology/pages/RadiologyPage';
// import PharmacyPage        from './features/pharmacy/pages/PharmacyPage';
// import BillingPage         from './features/billing/pages/BillingPage';
// import OcrVerifyPage       from './features/pharmacy/pages/OcrVerifyPage';
// import PatientDirectory   from './features/patients/pages/PatientDirectory';
// import PatientNew         from './features/patients/pages/PatientNew';
// import PatientProfile     from './features/patients/pages/PatientProfile';
// import BrandingPage         from './features/settings/pages/BrandingPage';
// import PrintSettings        from './features/settings/pages/PrintSettings';
// import SupportPage          from './features/support/pages/SupportPage';
// import DashboardPage        from './features/dashboard/pages/DashboardPage';
// import BillingMasterPage    from './features/settings/pages/BillingMasterPage';
// import ProfilePage          from './features/profile/pages/ProfilePage';
// import ReportsDashboard     from './features/reports/pages/ReportsDashboard';
// import OtPage               from './features/ot/pages/OtPage';
// import VitalsChartPage      from './features/ipd/pages/VitalsChartPage';
// import CertificatesPage     from './features/certificates/pages/CertificatesPage';
// import StaffPage            from './features/staff/pages/StaffPage';
// import PackagesPage         from './features/billing/pages/PackagesPage';
// import CreditNotesPage      from './features/billing/pages/CreditNotesPage';
// import TpaClaimsPage        from './features/billing/pages/TpaClaimsPage';
// import AppointmentsPage     from './features/appointments/pages/AppointmentsPage';
// import InventoryPage        from './features/inventory/pages/InventoryPage';

// import LandingPage from './LandingPage/LandingPage'

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       retry:      1,
//       staleTime:  30_000,
//       gcTime:     5 * 60_000,
//     },
//   },
// });

// const PLATFORM_ROLES = ['super_admin', 'support', 'billing_ops'];

// function PrivateRoute({ children }: { children: React.ReactNode }) {
//   const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
//   if (!isAuth) return <Navigate to="/login" replace/>;
//   // Platform admins belong in /admin, not hospital routes
//   if (user && PLATFORM_ROLES.includes(user.role)) return <Navigate to="/admin" replace/>;
//   return <>{children}</>;
// }

// function PublicRoute({ children }: { children: React.ReactNode }) {
//   const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
//   if (!isAuth) return <>{children}</>;
//   if (user && PLATFORM_ROLES.includes(user.role)) return <Navigate to="/admin" replace/>;
//   return <Navigate to="/dashboard" replace/>;
// }

// function AdminRoute({ children }: { children: React.ReactNode }) {
//   const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
//   if (!isAuth) return <Navigate to="/login" replace/>;
//   if (!user || !PLATFORM_ROLES.includes(user.role)) return <Navigate to="/opd" replace/>;
//   return <>{children}</>;
// }

// /**
//  * Guards a hospital route to specific roles.
//  * Redirects to /dashboard if the authenticated user's role (including additionalRoles)
//  * is not in the allowed list.
//  */
// function RoleRoute({ children, roles }: { children: React.ReactNode; roles: string[] }) {
//   const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
//   if (!isAuth) return <Navigate to="/login" replace/>;
//   const allRoles = [user?.role ?? '', ...(user?.additionalRoles ?? [])];
//   if (!allRoles.some(r => roles.includes(r))) return <Navigate to="/dashboard" replace/>;
//   return <>{children}</>;
// }

// const DASHBOARD_ROLES = [
//   'owner', 'hospital_admin', 'doctor', 'nurse', 'receptionist',
//   'lab_technician', 'radiologist', 'pharmacist', 'billing_staff', 'accountant',
// ];

// function RoleRedirect() {
//   const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
//   if (!isAuth) return <Navigate to="/login" replace/>;
//   if (user && PLATFORM_ROLES.includes(user.role)) return <Navigate to="/admin" replace/>;
//   if (user && DASHBOARD_ROLES.includes(user.role)) return <Navigate to="/dashboard" replace/>;
//   return <Navigate to="/opd" replace/>;
// }

// export default function App() {
//   useEffect(() => {
//     const cleanup = registerSyncListeners();
//     return cleanup;
//   }, []);

//   return (
//     <QueryClientProvider client={queryClient}>
//       <BrowserRouter>
//         <Routes>
//           {/* Public */}
//           <Route path="/" element={<LandingPage />} />
//           <Route path="/login"     element={<PublicRoute><LoginPage/></PublicRoute>}/>
//           <Route path="/mfa/setup" element={<MfaSetupPage/>}/>

//           {/* BBS Admin panel */}
//           <Route path="/admin" element={<AdminRoute><AdminLayout/></AdminRoute>}>
//             <Route index                   element={<AdminDashboard/>}/>
//             <Route path="hospitals"        element={<HospitalsList/>}/>
//             <Route path="hospitals/new"    element={<OnboardingPage autoStart/>}/>
//             <Route path="hospitals/:id"    element={<HospitalDetail/>}/>
//             <Route path="rbac"             element={<RbacMatrix/>}/>
//             <Route path="plans"            element={<PlansPage/>}/>
//             <Route path="upgrade-requests" element={<UpgradeRequestsPage/>}/>
//             <Route path="support"          element={<AdminSupportPage/>}/>
//             <Route path="debug/auth"       element={<AuthDebugPage/>}/>
//             <Route path="sys-logs"         element={<SystemLogsPage/>}/>
//           </Route>

//           {/* Hospital staff */}
//           <Route path="/" element={<PrivateRoute><DashboardLayout/></PrivateRoute>}>
//             <Route index              element={<RoleRedirect/>}/>
//             <Route path="dashboard"   element={<DashboardPage/>}/>
//             <Route path="opd"              element={<OpdQueuePage/>}/>
//             <Route path="appointments"     element={<AppointmentsPage/>}/>
//             <Route path="patients"         element={<PatientDirectory/>}/>
//             <Route path="patients/new"     element={<PatientNew/>}/>
//             <Route path="patients/:id"     element={<PatientProfile/>}/>
//             <Route path="users"   element={<RoleRoute roles={['hospital_admin','owner']}><UsersPage/></RoleRoute>}/>
//             <Route path="ipd"     element={<RoleRoute roles={['hospital_admin','owner','doctor','nurse']}><IpdBedBoardPage/></RoleRoute>}/>
//             <Route path="pathology" element={<RoleRoute roles={['hospital_admin','owner','doctor','lab_technician','nurse']}><LabPage/></RoleRoute>}/>
//             <Route path="radiology" element={<RoleRoute roles={['hospital_admin','owner','doctor','radiologist']}><RadiologyPage/></RoleRoute>}/>
//             <Route path="pharmacy"     element={<RoleRoute roles={['hospital_admin','owner','pharmacist','doctor']}><PharmacyPage/></RoleRoute>}/>
//             <Route path="ocr-verify"   element={<RoleRoute roles={['hospital_admin','owner','pharmacist','doctor']}><OcrVerifyPage/></RoleRoute>}/>
//             <Route path="billing"      element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant','receptionist']}><BillingPage/></RoleRoute>}/>
//             <Route path="reports"      element={<RoleRoute roles={['hospital_admin','owner','accountant','billing_staff']}><ReportsDashboard/></RoleRoute>}/>
//             <Route path="ot"           element={<RoleRoute roles={['hospital_admin','owner','doctor','nurse']}><OtPage/></RoleRoute>}/>
//             <Route path="ipd/vitals/:admissionId" element={<RoleRoute roles={['hospital_admin','owner','doctor','nurse']}><VitalsChartPage/></RoleRoute>}/>
//             <Route path="certificates" element={<RoleRoute roles={['hospital_admin','owner','doctor']}><CertificatesPage/></RoleRoute>}/>
//             <Route path="staff"        element={<RoleRoute roles={['hospital_admin','owner']}><StaffPage/></RoleRoute>}/>
//             <Route path="packages"     element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant']}><PackagesPage/></RoleRoute>}/>
//             <Route path="credit-notes" element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant']}><CreditNotesPage/></RoleRoute>}/>
//             <Route path="tpa-claims"   element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant']}><TpaClaimsPage/></RoleRoute>}/>
//             <Route path="inventory"    element={<RoleRoute roles={['hospital_admin','owner','pharmacist']}><InventoryPage/></RoleRoute>}/>
//             <Route path="settings"     element={<RoleRoute roles={['hospital_admin','owner']}><BrandingPage/></RoleRoute>}/>
//             <Route path="print-settings" element={<RoleRoute roles={['hospital_admin','owner']}><PrintSettings/></RoleRoute>}/>
//             <Route path="billing-master" element={<RoleRoute roles={['hospital_admin','owner','lab_technician','radiologist','pharmacist','billing_staff','accountant']}><BillingMasterPage/></RoleRoute>}/>
//             <Route path="profile"      element={<ProfilePage/>}/>
//             <Route path="sessions"     element={<SessionsPage/>}/>
//             <Route path="subscription" element={<SubscriptionPage/>}/>
//             <Route path="support"      element={<SupportPage/>}/>
//           </Route>

//           <Route path="*" element={<Navigate to="/login" replace/>}/>
//         </Routes>
//       </BrowserRouter>
//     </QueryClientProvider>
//   );
// }

// function ComingSoon({ title }: { title: string }) {
//   return (
//     <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-3">
//       <div className="text-navy/20"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg></div>
//       <h2 className="text-navy text-xl font-semibold">{title}</h2>
//       <p className="text-sm">This module is under active development</p>
//     </div>
//   );
// }


import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from './store/auth.store';
import { registerSyncListeners } from './lib/offline/sync';
import LoginPage       from './features/auth/pages/LoginPage';
import MfaSetupPage   from './features/auth/pages/MfaSetupPage';
import SessionsPage   from './features/sessions/pages/SessionsPage';
import DashboardLayout from './components/layout/DashboardLayout';
import OpdQueuePage    from './features/opd/pages/OpdQueuePage';
import UsersPage       from './features/users/pages/UsersPage';
import OnboardingPage  from './features/onboarding/pages/OnboardingPage';
import AdminLayout     from './features/admin/pages/AdminLayout';
import AdminDashboard  from './features/admin/pages/AdminDashboard';
import HospitalsList   from './features/admin/pages/HospitalsList';
import HospitalDetail  from './features/admin/pages/HospitalDetail';
import RbacMatrix           from './features/admin/pages/RbacMatrix';
import AuthDebugPage        from './features/admin/pages/AuthDebugPage';
import SystemLogsPage      from './features/admin/pages/SystemLogsPage';
import PlansPage            from './features/admin/pages/PlansPage';
import UpgradeRequestsPage  from './features/admin/pages/UpgradeRequestsPage';
import AdminSupportPage     from './features/admin/pages/AdminSupportPage';
import SubscriptionPage     from './features/hospital/pages/SubscriptionPage';
import IpdBedBoardPage     from './features/ipd/pages/IpdBedBoardPage';
import LabPage             from './features/lab/pages/LabPage';
import RadiologyPage       from './features/radiology/pages/RadiologyPage';
import PharmacyPage        from './features/pharmacy/pages/PharmacyPage';
import BillingPage         from './features/billing/pages/BillingPage';
import OcrVerifyPage       from './features/pharmacy/pages/OcrVerifyPage';
import PatientDirectory   from './features/patients/pages/PatientDirectory';
import PatientNew         from './features/patients/pages/PatientNew';
import PatientProfile     from './features/patients/pages/PatientProfile';
import BrandingPage         from './features/settings/pages/BrandingPage';
import PrintSettings        from './features/settings/pages/PrintSettings';
import SupportPage          from './features/support/pages/SupportPage';
import DashboardPage        from './features/dashboard/pages/DashboardPage';
import BillingMasterPage    from './features/settings/pages/BillingMasterPage';
import ProfilePage          from './features/profile/pages/ProfilePage';
import ReportsDashboard     from './features/reports/pages/ReportsDashboard';
import OtPage               from './features/ot/pages/OtPage';
import VitalsChartPage      from './features/ipd/pages/VitalsChartPage';
import CertificatesPage     from './features/certificates/pages/CertificatesPage';
import StaffPage            from './features/staff/pages/StaffPage';
import PackagesPage         from './features/billing/pages/PackagesPage';
import CreditNotesPage      from './features/billing/pages/CreditNotesPage';
import TpaClaimsPage        from './features/billing/pages/TpaClaimsPage';
import AppointmentsPage     from './features/appointments/pages/AppointmentsPage';
import InventoryPage        from './features/inventory/pages/InventoryPage';

import LandingPage from './LandingPage/LandingPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry:      1,
      staleTime:  30_000,
      gcTime:     5 * 60_000,
    },
  },
});

const PLATFORM_ROLES = ['super_admin', 'support', 'billing_ops'];

const DASHBOARD_ROLES = [
  'owner', 'hospital_admin', 'doctor', 'nurse', 'receptionist',
  'lab_technician', 'radiologist', 'pharmacist', 'billing_staff', 'accountant',
];

/** Where to send an authenticated user, based on role. */
function getPostLoginPath(user: { role: string } | null | undefined): string {
  if (user && PLATFORM_ROLES.includes(user.role)) return '/admin';
  if (user && DASHBOARD_ROLES.includes(user.role)) return '/dashboard';
  return '/opd';
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
  if (!isAuth) return <Navigate to="/login" replace/>;
  // Platform admins belong in /admin, not hospital routes
  if (user && PLATFORM_ROLES.includes(user.role)) return <Navigate to="/admin" replace/>;
  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
  if (!isAuth) return <>{children}</>;
  return <Navigate to={getPostLoginPath(user)} replace/>;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
  if (!isAuth) return <Navigate to="/login" replace/>;
  if (!user || !PLATFORM_ROLES.includes(user.role)) return <Navigate to="/opd" replace/>;
  return <>{children}</>;
}

/**
 * Guards a hospital route to specific roles.
 * Redirects to /dashboard if the authenticated user's role (including additionalRoles)
 * is not in the allowed list.
 */
function RoleRoute({ children, roles }: { children: React.ReactNode; roles: string[] }) {
  const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
  if (!isAuth) return <Navigate to="/login" replace/>;
  const allRoles = [user?.role ?? '', ...(user?.additionalRoles ?? [])];
  if (!allRoles.some(r => roles.includes(r))) return <Navigate to="/dashboard" replace/>;
  return <>{children}</>;
}

/**
 * Root ("/") route.
 * - Not authenticated  -> show the public LandingPage.
 * - Authenticated      -> redirect straight to the right area for that role.
 *
 * IMPORTANT: This must be the ONLY route registered for path="/". Previously
 * there was a second <Route path="/"> (the private DashboardLayout) with an
 * `index` child. React Router gives index routes a scoring bonus, so on a
 * tie for "/" that branch was winning over the plain LandingPage route,
 * causing PrivateRoute to fire first and bounce unauthenticated users to
 * /login before the landing page ever rendered.
 */
function RootRoute() {
  const { isAuth, user } = useAuthStore(s => ({ isAuth: s.isAuth, user: s.user }));
  if (!isAuth) return <LandingPage/>;
  return <Navigate to={getPostLoginPath(user)} replace/>;
}

export default function App() {
  useEffect(() => {
    const cleanup = registerSyncListeners();
    return cleanup;
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public landing page — the only route registered for "/" */}
          <Route path="/" element={<RootRoute/>} />
          <Route path="/login"     element={<PublicRoute><LoginPage/></PublicRoute>}/>
          <Route path="/mfa/setup" element={<MfaSetupPage/>}/>

          {/* BBS Admin panel */}
          <Route path="/admin" element={<AdminRoute><AdminLayout/></AdminRoute>}>
            <Route index                   element={<AdminDashboard/>}/>
            <Route path="hospitals"        element={<HospitalsList/>}/>
            <Route path="hospitals/new"    element={<OnboardingPage autoStart/>}/>
            <Route path="hospitals/:id"    element={<HospitalDetail/>}/>
            <Route path="rbac"             element={<RbacMatrix/>}/>
            <Route path="plans"            element={<PlansPage/>}/>
            <Route path="upgrade-requests" element={<UpgradeRequestsPage/>}/>
            <Route path="support"          element={<AdminSupportPage/>}/>
            <Route path="debug/auth"       element={<AuthDebugPage/>}/>
            <Route path="sys-logs"         element={<SystemLogsPage/>}/>
          </Route>

          {/*
            Hospital staff shell.
            NOTE: no `path` here (pathless/layout route) and no `index`
            child — that avoids re-claiming the exact "/" path. Children
            below still resolve to their own absolute-looking paths
            ("/dashboard", "/opd", etc.) because a pathless parent doesn't
            add any URL segment.
          */}
          <Route element={<PrivateRoute><DashboardLayout/></PrivateRoute>}>
            <Route path="dashboard"   element={<DashboardPage/>}/>
            <Route path="opd"              element={<OpdQueuePage/>}/>
            <Route path="appointments"     element={<AppointmentsPage/>}/>
            <Route path="patients"         element={<PatientDirectory/>}/>
            <Route path="patients/new"     element={<PatientNew/>}/>
            <Route path="patients/:id"     element={<PatientProfile/>}/>
            <Route path="users"   element={<RoleRoute roles={['hospital_admin','owner']}><UsersPage/></RoleRoute>}/>
            <Route path="ipd"     element={<RoleRoute roles={['hospital_admin','owner','doctor','nurse']}><IpdBedBoardPage/></RoleRoute>}/>
            <Route path="pathology" element={<RoleRoute roles={['hospital_admin','owner','doctor','lab_technician','nurse']}><LabPage/></RoleRoute>}/>
            <Route path="radiology" element={<RoleRoute roles={['hospital_admin','owner','doctor','radiologist']}><RadiologyPage/></RoleRoute>}/>
            <Route path="pharmacy"     element={<RoleRoute roles={['hospital_admin','owner','pharmacist','doctor']}><PharmacyPage/></RoleRoute>}/>
            <Route path="ocr-verify"   element={<RoleRoute roles={['hospital_admin','owner','pharmacist','doctor']}><OcrVerifyPage/></RoleRoute>}/>
            <Route path="billing"      element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant','receptionist']}><BillingPage/></RoleRoute>}/>
            <Route path="reports"      element={<RoleRoute roles={['hospital_admin','owner','accountant','billing_staff']}><ReportsDashboard/></RoleRoute>}/>
            <Route path="ot"           element={<RoleRoute roles={['hospital_admin','owner','doctor','nurse']}><OtPage/></RoleRoute>}/>
            <Route path="ipd/vitals/:admissionId" element={<RoleRoute roles={['hospital_admin','owner','doctor','nurse']}><VitalsChartPage/></RoleRoute>}/>
            <Route path="certificates" element={<RoleRoute roles={['hospital_admin','owner','doctor']}><CertificatesPage/></RoleRoute>}/>
            <Route path="staff"        element={<RoleRoute roles={['hospital_admin','owner']}><StaffPage/></RoleRoute>}/>
            <Route path="packages"     element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant']}><PackagesPage/></RoleRoute>}/>
            <Route path="credit-notes" element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant']}><CreditNotesPage/></RoleRoute>}/>
            <Route path="tpa-claims"   element={<RoleRoute roles={['hospital_admin','owner','billing_staff','accountant']}><TpaClaimsPage/></RoleRoute>}/>
            <Route path="inventory"    element={<RoleRoute roles={['hospital_admin','owner','pharmacist']}><InventoryPage/></RoleRoute>}/>
            <Route path="settings"     element={<RoleRoute roles={['hospital_admin','owner']}><BrandingPage/></RoleRoute>}/>
            <Route path="print-settings" element={<RoleRoute roles={['hospital_admin','owner']}><PrintSettings/></RoleRoute>}/>
            <Route path="billing-master" element={<RoleRoute roles={['hospital_admin','owner','lab_technician','radiologist','pharmacist','billing_staff','accountant']}><BillingMasterPage/></RoleRoute>}/>
            <Route path="profile"      element={<ProfilePage/>}/>
            <Route path="sessions"     element={<SessionsPage/>}/>
            <Route path="subscription" element={<SubscriptionPage/>}/>
            <Route path="support"      element={<SupportPage/>}/>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace/>}/>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

function ComingSoon({ title }: { title: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-3">
      <div className="text-navy/20"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg></div>
      <h2 className="text-navy text-xl font-semibold">{title}</h2>
      <p className="text-sm">This module is under active development</p>
    </div>
  );
}